import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/PageHeader";
import { ChatPanel } from "@/components/ai/ChatPanel";
import { EpiAnalysis } from "@/components/ai/EpiAnalysis";
import { DraftPanel } from "@/components/ai/DraftPanel";
import { DirectoryQuality } from "@/components/ai/DirectoryQuality";

export default function AiPage() {
  return (
    <div className="space-y-8" data-testid="ai-page">
      <PageHeader title="Assistant IA" subtitle="Claude vous aide à lire vos statistiques, analyser les épidémies, rédiger vos messages et fiabiliser l'annuaire. Seules des données anonymes lui sont transmises." />
      <Tabs defaultValue="chat">
        <TabsList className="bg-white border border-stone-200 flex-wrap h-auto">
          <TabsTrigger value="chat" data-testid="ai-tab-chat">Assistant</TabsTrigger>
          <TabsTrigger value="epi" data-testid="ai-tab-epi">Analyse des épidémies</TabsTrigger>
          <TabsTrigger value="draft" data-testid="ai-tab-draft">Rédaction</TabsTrigger>
          <TabsTrigger value="quality" data-testid="ai-tab-quality">Qualité de l'annuaire</TabsTrigger>
        </TabsList>
        <TabsContent value="chat" className="mt-6"><ChatPanel /></TabsContent>
        <TabsContent value="epi" className="mt-6"><EpiAnalysis /></TabsContent>
        <TabsContent value="draft" className="mt-6"><DraftPanel /></TabsContent>
        <TabsContent value="quality" className="mt-6"><DirectoryQuality /></TabsContent>
      </Tabs>
    </div>
  );
}
